"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuotedColumnParser = void 0;

var ColumnFormatter_1 = require("./ColumnFormatter");

var Token_1 = require("../Token");

var QuotedColumnParser = /*#__PURE__*/function () {
  function QuotedColumnParser(parserOptions) {
    _classCallCheck(this, QuotedColumnParser);

    this.parserOptions = parserOptions;
    this.columnFormatter = new ColumnFormatter_1.ColumnFormatter(parserOptions);
  }

  _createClass(QuotedColumnParser, [{
    key: "parse",
    value: function parse(scanner) {
      if (!scanner.hasMoreCharacters) {
        return null;
      }

      var originalCursor = scanner.cursor;

      var _this$gatherDataBetwe = this.gatherDataBetweenQuotes(scanner),
          foundClosingQuote = _this$gatherDataBetwe.foundClosingQuote,
          col = _this$gatherDataBetwe.col;

      if (!foundClosingQuote) {
        // reset the cursor to the original
        scanner.advanceTo(originalCursor); // if we didnt find a closing quote but we potentially have more data then skip the parsing
        // and return the original scanner.

        if (!scanner.hasMoreData) {
          throw new Error("Parse Error: missing closing: '".concat(this.parserOptions.quote || '', "' in line: at '").concat(scanner.lineFromCursor.replace(/[\r\n]/g, "\\n'"), "'"));
        }

        return null;
      }

      this.checkForMalformedColumn(scanner);
      return col;
    }
  }, {
    key: "gatherDataBetweenQuotes",
    value: function gatherDataBetweenQuotes(scanner) {
      var parserOptions = this.parserOptions;
      var foundStartingQuote = false;
      var foundClosingQuote = false;
      var characters = [];
      var nextToken = scanner.nextCharacterToken;

      for (; !foundClosingQuote && nextToken !== null; nextToken = scanner.nextCharacterToken) {
        var isQuote = Token_1.Token.isTokenQuote(nextToken, parserOptions); // ignore first quote

        if (!foundStartingQuote && isQuote) {
          foundStartingQuote = true;
        } else if (foundStartingQuote) {
          if (Token_1.Token.isTokenEscapeCharacter(nextToken, parserOptions)) {
            // advance past the escape character so we can get the next one in line
            scanner.advancePastToken(nextToken);
            var tokenFollowingEscape = scanner.nextCharacterToken; // if the character following the escape is a quote character then just add
            // the quote and advance to that character

            if (tokenFollowingEscape !== null && (Token_1.Token.isTokenQuote(tokenFollowingEscape, parserOptions) || Token_1.Token.isTokenEscapeCharacter(tokenFollowingEscape, parserOptions))) {
              characters.push(tokenFollowingEscape.token);
              nextToken = tokenFollowingEscape;
            } else if (isQuote) {
              // if the escape is also a quote then we found our closing quote and finish early
              foundClosingQuote = true;
            } else {
              // other wise add the escape token to the characters since it wast escaping anything
              characters.push(nextToken.token);
            }
          } else if (isQuote) {
            // we found our closing quote!
            foundClosingQuote = true;
          } else {
            // add the token to the characters
            characters.push(nextToken.token);
          }
        }

        scanner.advancePastToken(nextToken);
      }

      return {
        col: this.columnFormatter.format(characters.join('')),
        foundClosingQuote: foundClosingQuote
      };
    }
  }, {
    key: "checkForMalformedColumn",
    value: function checkForMalformedColumn(scanner) {
      var parserOptions = this.parserOptions;
      var nextNonSpaceToken = scanner.nextNonSpaceToken;

      if (nextNonSpaceToken) {
        var isNextTokenADelimiter = Token_1.Token.isTokenDelimiter(nextNonSpaceToken, parserOptions);
        var isNextTokenARowDelimiter = Token_1.Token.isTokenRowDelimiter(nextNonSpaceToken);

        if (!(isNextTokenADelimiter || isNextTokenARowDelimiter)) {
          // if the final quote was NOT followed by a column (,) or row(\n) delimiter then its a bad column
          // tldr: only part of the column was quoted
          var linePreview = scanner.lineFromCursor.substr(0, 10).replace(/[\r\n]/g, "\\n'");
          throw new Error("Parse Error: expected: '".concat(parserOptions.escapedDelimiter, "' OR new line got: '").concat(nextNonSpaceToken.token, "'. at '").concat(linePreview));
        }

        scanner.advanceToToken(nextNonSpaceToken);
      } else if (!scanner.hasMoreData) {
        scanner.advancePastLine();
      }
    }
  }]);

  return QuotedColumnParser;
}();

exports.QuotedColumnParser = QuotedColumnParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wYXJzZXIvY29sdW1uL1F1b3RlZENvbHVtblBhcnNlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUEsSUFBQSxpQkFBQSxHQUFBLE9BQUEsQ0FBQSxtQkFBQSxDQUFBOztBQUdBLElBQUEsT0FBQSxHQUFBLE9BQUEsQ0FBQSxVQUFBLENBQUE7O0lBT2Esa0I7QUFLVCw4QkFBbUIsYUFBbkIsRUFBK0M7QUFBQTs7QUFDM0MsU0FBSyxhQUFMLEdBQXFCLGFBQXJCO0FBQ0EsU0FBSyxlQUFMLEdBQXVCLElBQUksaUJBQUEsQ0FBQSxlQUFKLENBQW9CLGFBQXBCLENBQXZCO0FBQ0g7Ozs7V0FFTSxlQUFNLE9BQU4sRUFBc0I7QUFDekIsVUFBSSxDQUFDLE9BQU8sQ0FBQyxpQkFBYixFQUFnQztBQUM1QixlQUFPLElBQVA7QUFDSDs7QUFDRCxVQUFNLGNBQWMsR0FBRyxPQUFPLENBQUMsTUFBL0I7O0FBSnlCLGtDQUtVLEtBQUssdUJBQUwsQ0FBNkIsT0FBN0IsQ0FMVjtBQUFBLFVBS2pCLGlCQUxpQix5QkFLakIsaUJBTGlCO0FBQUEsVUFLRSxHQUxGLHlCQUtFLEdBTEY7O0FBTXpCLFVBQUksQ0FBQyxpQkFBTCxFQUF3QjtBQUNwQjtBQUNBLFFBQUEsT0FBTyxDQUFDLFNBQVIsQ0FBa0IsY0FBbEIsRUFGb0IsQ0FHcEI7QUFDQTs7QUFDQSxZQUFJLENBQUMsT0FBTyxDQUFDLFdBQWIsRUFBMEI7QUFDdEIsZ0JBQU0sSUFBSSxLQUFKLDBDQUVFLEtBQUssYUFBTCxDQUFtQixLQUFuQixJQUE0QixFQUY5Qiw0QkFHZ0IsT0FBTyxDQUFDLGNBQVIsQ0FBdUIsT0FBdkIsQ0FBK0IsU0FBL0IsRUFBMEMsTUFBMUMsQ0FIaEIsT0FBTjtBQUtIOztBQUNELGVBQU8sSUFBUDtBQUNIOztBQUNELFdBQUssdUJBQUwsQ0FBNkIsT0FBN0I7QUFDQSxhQUFPLEdBQVA7QUFDSDs7O1dBRU8saUNBQXdCLE9BQXhCLEVBQXdDO0FBQUEsVUFDcEMsYUFEb0MsR0FDbEIsSUFEa0IsQ0FDcEMsYUFEb0M7QUFFNUMsVUFBSSxrQkFBa0IsR0FBRyxLQUF6QjtBQUNBLFVBQUksaUJBQWlCLEdBQUcsS0FBeEI7QUFDQSxVQUFNLFVBQVUsR0FBRyxFQUFuQjtBQUNBLFVBQUksU0FBUyxHQUFpQixPQUFPLENBQUMsa0JBQXRDOztBQUNBLGFBQU8sQ0FBQyxpQkFBRCxJQUFzQixTQUFTLEtBQUssSUFBM0MsRUFBaUQsU0FBUyxHQUFHLE9BQU8sQ0FBQyxrQkFBckUsRUFBeUY7QUFDckYsWUFBTSxPQUFPLEdBQUcsT0FBQSxDQUFBLEtBQUEsQ0FBTSxZQUFOLENBQW1CLFNBQW5CLEVBQThCLGFBQTlCLENBQWhCLENBRHFGLENBRXJGOztBQUNBLFlBQUksQ0FBQyxrQkFBRCxJQUF1QixPQUEzQixFQUFvQztBQUNoQyxVQUFBLGtCQUFrQixHQUFHLElBQXJCO0FBQ0gsU0FGRCxNQUVPLElBQUksa0JBQUosRUFBd0I7QUFDM0IsY0FBSSxPQUFBLENBQUEsS0FBQSxDQUFNLHNCQUFOLENBQTZCLFNBQTdCLEVBQXdDLGFBQXhDLENBQUosRUFBNEQ7QUFDeEQ7QUFDQSxZQUFBLE9BQU8sQ0FBQyxnQkFBUixDQUF5QixTQUF6QjtBQUNBLGdCQUFNLG9CQUFvQixHQUFHLE9BQU8sQ0FBQyxrQkFBckMsQ0FId0QsQ0FJeEQ7QUFDQTs7QUFDQSxnQkFDSSxvQkFBb0IsS0FBSyxJQUF6QixLQUNDLE9BQUEsQ0FBQSxLQUFBLENBQU0sWUFBTixDQUFtQixvQkFBbkIsRUFBeUMsYUFBekMsS0FDRyxPQUFBLENBQUEsS0FBQSxDQUFNLHNCQUFOLENBQTZCLG9CQUE3QixFQUFtRCxhQUFuRCxDQUZKLENBREosRUFJRTtBQUNFLGNBQUEsVUFBVSxDQUFDLElBQVgsQ0FBZ0Isb0JBQW9CLENBQUMsS0FBckM7QUFDQSxjQUFBLFNBQVMsR0FBRyxvQkFBWjtBQUNILGFBUEQsTUFPTyxJQUFJLE9BQUosRUFBYTtBQUNoQjtBQUNBLGNBQUEsaUJBQWlCLEdBQUcsSUFBcEI7QUFDSCxhQUhNLE1BR0E7QUFDSDtBQUNBLGNBQUEsVUFBVSxDQUFDLElBQVgsQ0FBZ0IsU0FBUyxDQUFDLEtBQTFCO0FBQ0g7QUFDSixXQXBCRCxNQW9CTyxJQUFJLE9BQUosRUFBYTtBQUNoQjtBQUNBLFlBQUEsaUJBQWlCLEdBQUcsSUFBcEI7QUFDSCxXQUhNLE1BR0E7QUFDSDtBQUNBLFlBQUEsVUFBVSxDQUFDLElBQVgsQ0FBZ0IsU0FBUyxDQUFDLEtBQTFCO0FBQ0g7QUFDSjs7QUFDRCxRQUFBLE9BQU8sQ0FBQyxnQkFBUixDQUF5QixTQUF6QjtBQUNIOztBQUNELGFBQU87QUFBRSxRQUFBLEdBQUcsRUFBRSxLQUFLLGVBQUwsQ0FBcUIsTUFBckIsQ0FBNEIsVUFBVSxDQUFDLElBQVgsQ0FBZ0IsRUFBaEIsQ0FBNUIsQ0FBUDtBQUF5RCxRQUFBLGlCQUFpQixFQUFqQjtBQUF6RCxPQUFQO0FBQ0g7OztXQUVPLGlDQUF3QixPQUF4QixFQUF3QztBQUFBLFVBQ3BDLGFBRG9DLEdBQ2xCLElBRGtCLENBQ3BDLGFBRG9DO0FBQUEsVUFFcEMsaUJBRm9DLEdBRWQsT0FGYyxDQUVwQyxpQkFGb0M7O0FBRzVDLFVBQUksaUJBQUosRUFBdUI7QUFDbkIsWUFBTSxxQkFBcUIsR0FBRyxPQUFBLENBQUEsS0FBQSxDQUFNLGdCQUFOLENBQXVCLGlCQUF2QixFQUEwQyxhQUExQyxDQUE5QjtBQUNBLFlBQU0sd0JBQXdCLEdBQUcsT0FBQSxDQUFBLEtBQUEsQ0FBTSxtQkFBTixDQUEwQixpQkFBMUIsQ0FBakM7O0FBQ0EsWUFBSSxFQUFFLHFCQUFxQixJQUFJLHdCQUEzQixDQUFKLEVBQTBEO0FBQ3REO0FBQ0E7QUFDQSxjQUFNLFdBQVcsR0FBRyxPQUFPLENBQUMsY0FBUixDQUF1QixNQUF2QixDQUE4QixDQUE5QixFQUFpQyxFQUFqQyxFQUFxQyxPQUFyQyxDQUE2QyxTQUE3QyxFQUF3RCxNQUF4RCxDQUFwQjtBQUNBLGdCQUFNLElBQUksS0FBSixtQ0FDeUIsYUFBYSxDQUFDLGdCQUR2QyxpQ0FDOEUsaUJBQWlCLENBQUMsS0FEaEcsb0JBQytHLFdBRC9HLEVBQU47QUFHSDs7QUFDRCxRQUFBLE9BQU8sQ0FBQyxjQUFSLENBQXVCLGlCQUF2QjtBQUNILE9BWkQsTUFZTyxJQUFJLENBQUMsT0FBTyxDQUFDLFdBQWIsRUFBMEI7QUFDN0IsUUFBQSxPQUFPLENBQUMsZUFBUjtBQUNIO0FBQ0o7Ozs7OztBQWpHTCxPQUFBLENBQUEsa0JBQUEsR0FBQSxrQkFBQSIsInNvdXJjZVJvb3QiOiIifQ==